<template>
  <div class="login-content">
    <div class="login-logo">
      <a><span>Kellner</span></a>
    </div>
    <div class="login-form">
      <h4>Inicio de sesión de administrador</h4>
      <div>
        <div class="form-group">
          <label>Correo</label>
          <input
            type="email"
            v-model="email"
            class="form-control"
            placeholder="Correo"
          />
        </div>
        <div class="form-group">
          <label>Contraseña</label>
          <input
            type="password"
            v-model="password"
            class="form-control"
            placeholder="Contraseña"
          />
        </div>
        <div class="checkbox">
          <label> <input type="checkbox" /> Recuérdame </label>
          <label class="pull-right">
            <a>¿Olvidaste tu contraseña?</a>
          </label>
        </div>
        <button
          class="btn btn-primary btn-flat m-b-30 m-t-30"
          @click="loginUser"
        >
          Iniciar sesión
        </button>
        <div class="register-link m-t-15 text-center">
          <p>
            ¿No tienes una cuenta?
            <router-link to="/register"><a> Regístrate</a></router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import router from "@/router.js";

export default {
  methods: {
    loginUser: function() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => this.isUserLogged())
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // [START_EXCLUDE]
          if (errorCode === "auth/wrong-password") {
            alert("Wrong password.");
          } else {
            alert(errorMessage);
          }
          console.log(error);
        });
    },
    isUserLogged: function() {
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          console.log(user.displayName);
          let userType = user.displayName.split("/")[0];
          if (userType == "0" || userType == "1") {
            router.push("/f2a").catch(err => {
              console.log(err);
            });
          } else {
            alert("No cuentas con los privilegios para usar esta aplicación.");
            firebase.auth().signOut();
            router.go();
          }
        }
      });
    }
  },
  mounted() {
    this.isUserLogged()
  },
  data() {
    return {
      email: "",
      password: ""
    };
  }
};
</script>
